'use strict';

import React from 'react';
import {eventEmitter} from '../../../../common/baseData';
import Icon from '../../../../Componentsv2/Icon/Icon';

function ProductButtons(props) {

  let availableState = props.data.PROPERTIES.NALICHIE.VALUE;

  const handleBuyAction = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!props.inBasket) {
      props.onAddToBasket(e);
    } else {
      eventEmitter.emit('openSmallCart');
    }
  }

  const handlePreOrderAction = (e) => {
    e.preventDefault();
    e.stopPropagation();
    availableState === 'Ожидается' ?
      eventEmitter.emit('preOrder', {productId: props.data.ID, productMerchant: props.data.PROPERTY_CH_MERCHANT_NAME}) :
      eventEmitter.emit('reportAvailability',
        {productId: props.data.ID, productMerchant: props.data.PROPERTY_CH_MERCHANT_NAME});
  }

  function onOpenCreditCard() {
    if (!props.inBasket) {
      eventEmitter.emit('showLoader');
      eventEmitter.emit('addToCart', {
        productId: props.data.ID,
        openWindow: false
      })
      eventEmitter.once('addedToCart', () => {
        eventEmitter.emit('openCreditBasket')
      })
    } else {
      eventEmitter.emit('hideLoader');
      eventEmitter.emit('openCreditBasket')
    }
  }

  return (
      <>
        {
          availableState === "В наличии" &&
          parseInt(props.data.PRICE) > 0 ?
            <>
              {
                (props.data.WARRANTY_DATA.TYPE !== 2 ||
                  (props.data.WARRANTY_DATA.TYPE === 2 &&
                    props.data.WARRANTY_DATA.RELATED_PRODUCTS_IN_BASKET)) ?
                  <a href="#"
                     onClick={handleBuyAction}
                     className={`buy-btn_mini`}
                     style={{
                       background: props.data.BUTTON_COLOR_DATA &&
                       props.data.BUTTON_COLOR_DATA.length ?
                         props.data.BUTTON_COLOR_DATA :
                         '#6364ff',
                     }}>
                    {
                      props.inBasket ?
                      <>
                        <i data-show="in-basket" onClick={(e) => {
                          if (props.inBasket) eventEmitter.emit(
                            'openSmallCart');
                        }}>
                          <svg xmlns="http://www.w3.org/2000/svg"
                               width="22" height="27"
                               viewBox="-5 0 29 27" id="ic-in-basket"
                               y="1324">
                            <path
                              d="M1.479 11.404L7.11 15.56M17.377 1.528L7.194 15.585"
                              fill="none"
                              stroke="#FFF" strokeLinecap="square"
                              strokeWidth="1.5"/>
                          </svg>
                        </i>
                        <span className="text-white text-[12px] h-full flex items-center">{props.messages.CT_BCI_TPL_IN_BASKET}</span>
                      </> :
                      <>
                        <i data-show="basket">
                          <svg xmlns="http://www.w3.org/2000/svg"
                               width="25" height="33"
                               viewBox="-5 0 33 33" id="ic-basket"
                               y="553">
                            <g fill="none" fillRule="evenodd"
                               stroke={props.data.BUTTON_COLOR_DATA &&
                               props.data.BUTTON_COLOR_DATA.length ?
                                 props.data.BUTTON_COLOR_DATA :
                                 '#fff'}
                               strokeWidth="1.5"
                               opacity=".6"
                               transform="translate(.414 1.275)">
                              <path
                                d="M.583.022h3.835l2.356 13.925h11.101l3.452-9.397H5.618"/>
                              <ellipse cx="7.365" cy="18.686" rx="1.758"
                                       ry="1.756"/>
                              <ellipse cx="16.706" cy="18.686"
                                       rx="1.758" ry="1.756"/>
                            </g>
                          </svg>
                        </i>
                        <span className="text-white text-[12px] h-full flex items-center">{props.messages.CT_BCI_TPL_BUY}</span>
                      </>
                  }
                </a> :
                <></>
              }
              {
                props.isMobile &&
                props.data.CREDIT_SERVICES &&
                Object.keys(props.data.CREDIT_SERVICES).length > 0 &&
                props.data.MONTHLY_PAYMENT_FORMATED &&
                  <button
                    className="w-full flex items-center justify-center text-blue-primary !text-[12px] h-[34px] !border-blue-primary !border border-solid rounded-[14px] !p-0 !bg-transparent"
                    data-current-product-id={props.data.ID} onClick={onOpenCreditCard}>
                    <span className="text-[12px]">{props.messages.CT_BCI_TPL_PAY_LATE.replace('#PRICE#', props.data.MONTHLY_PAYMENT_FORMATED)}</span>
                  </button>
              }
            </> :
            <></>
        }
        {
          availableState === 'Ожидается' || availableState === 'Нет в наличии' ?
              <div className={`btn-holder not-available-holder`}>
                <a href="#"
                   data-container="buy"
                   data-product-id={props.data.ID}
                   data-use={availableState === 'Ожидается' ? 'pre-order' : 'report'}
                   className={`btn btn-block btn-border not-available-btn ${
                     availableState === 'Ожидается'
                       ? '!py-[2px] !px-[8px] !h-[34px] desktop:!h-11 desktop:!py-[7px] desktop:!px-[14px]'
                       : '!pt-[4px] !pb-[2px] !px-[8px] !h-[34px] desktop:!h-11 desktop:!pt-[10px] desktop:!pb-[7px] desktop:!px-[14px]'
                   }`}
                   onClick={handlePreOrderAction}>
                  {
                    availableState === 'Нет в наличии' ?
                      <Icon name={'report-availability-icon'} className="h-[22px] w-[25px]"/> :
                      <Icon name={'preorder-icon'} className="h-[25px] w-[25px]"/>
                  }
                </a>
              </div> :
            <></>
        }
        {
          availableState === 'Снят с производства' &&
          props.hasOwnProperty('newModelsCategory') ?
            <a href={props.newModelsCategory ?
              props.newModelsCategory.SECTION_PAGE_URL :
              props.newModelsCategory}
               className="link">
              {props.messages.CT_BCI_TPL_WATCH_NEW_MODELS} {Array.isArray(
              props.newModelsCategory) ?
              props.newModelsCategory.NAME :
              ''}
            </a> :
            <></>
        }
      </>
  );
}

export default ProductButtons;